import { axios } from '~/libs/axios';
import { type TSubscription, type TSubscriptionPlan } from '~/types';

const getPlans = async (): Promise<TSubscriptionPlan[]> => {
  const { data } = await axios.get<TSubscriptionPlan[]>('/subscriptions/plans');
  return data;
};

const getMySubscription = async (): Promise<TSubscription | null> => {
  const { data } = await axios.get<TSubscription | null>('/subscriptions/me');
  return data;
};

const verify = async (
  txHash: string,
  walletAddress: string,
): Promise<TSubscription> => {
  const { data } = await axios.post<TSubscription>('/subscriptions/verify', {
    txHash,
    walletAddress,
  });
  return data;
};

export const subscriptionAPI = {
  getPlans,
  getMySubscription,
  verify,
};
